<template>
  <v-data-iterator
    :items="responses"
    :items-per-page.sync="itemsPerPage"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="props">
      <v-row>
        <v-col
          v-for="item in props.items"
          :key="item.pk"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-expansion-panels>
            <v-card>
              <v-card-title class="headline">
                {{ getSurveyTitle(item.survey) }}
              </v-card-title>
              <v-card-subtitle v-if="validEmail">
                This user has no valid email for contact.
              </v-card-subtitle>
              <!-- Conversations Component -->
              <ConversationInteraction
                :stakeholder-response="item"
                :valid-email="validEmail"
              />
              <v-divider />
              <v-expansion-panel
                v-for="(value, key) in item.survey_metadata.meta_data"
                :key="value + key"
              >
                <v-expansion-panel-header v-if="typeof(value) == 'string'">
                  {{ item.survey_metadata.meta_data[key] }}
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="typeof(value) == 'string' && item.survey_metadata.meta_data.questionsWithArrayForAnswer.includes(key)">
                  <ul
                    v-for="(answerInArray, index) in item.response_json[key]"
                    :key="index"
                  >
                    <li v-if="!['Other', 'other'].includes(answerInArray)">
                      {{ answerInArray }}
                    </li>
                    <p v-else>
                      Other: <br>
                      {{ item.response_json[key+"-Comment"] }}
                    </p>
                  </ul>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else-if="typeof(value) === 'string' && typeof(item.response_json[key]) === 'number'">
                  {{ item.survey_metadata.meta_data.dynamicOptions[key][item.response_json[key] - 1] }}
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>
                  {{ item.response_json[key] }}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</template>
<script>
import ConversationInteraction from './ConversationInteraction'

import { mapState } from 'vuex';

export default {
  name: "StakeholderResponses",
  components: {
    ConversationInteraction
  },
  props: { responses: { type: Array, default: () => [] }, validEmail: { type: Boolean, default: () => true } },
  data() {
    return {
      itemsPerPage: 4,
      itemsPerPageOptions: [4, 8, 12],
    }
  },
  computed: {
    ...mapState({
      surveys: state => state.survey.surveys,
    })
  },
  methods: {
    getSurveyTitle(surveyPk) {
      return this.surveys.find(survey => survey.pk === surveyPk).name;
    },
  }
}
</script>
<style scoped>
.v-card__title {
  word-break: normal;
}
</style>